import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };
  const navLinks = [{
    label: 'Deal Flow',
    id: 'deals'
  }, {
    label: 'Completed Deals',
    id: 'completed'
  }, {
    label: 'How It Works',
    id: 'how-it-works'
  }, {
    label: 'About',
    id: 'about'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy shadow-lg' : 'bg-navy/95'}`} data-id="element-273">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-274">
        <div className="flex justify-between items-center h-20" data-id="element-275">
          <button onClick={() => scrollToSection('hero')} className="text-white font-serif text-xl sm:text-2xl font-semibold hover:text-gold transition-colors" data-id="element-276">
            CaboDealFlow.com
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-277">
            {navLinks.map(link => <button key={link.id} onClick={() => scrollToSection(link.id)} className="text-white/90 hover:text-gold transition-colors text-sm font-medium" data-id="element-278">
                {link.label}
              </button>)}
            <button onClick={() => scrollToSection('deal-report')} className="bg-gold hover:bg-gold-light text-navy px-6 py-2.5 rounded font-semibold transition-colors text-sm" data-id="element-279">
              Access Deal Report
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden text-white p-2" data-id="element-280">
            {isMobileMenuOpen ? <XIcon size={24} data-id="element-281" /> : <MenuIcon size={24} data-id="element-282" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="md:hidden pb-6 space-y-4" data-id="element-283">
            {navLinks.map(link => <button key={link.id} onClick={() => scrollToSection(link.id)} className="block w-full text-left text-white/90 hover:text-gold transition-colors py-2" data-id="element-284">
                {link.label}
              </button>)}
            <button onClick={() => scrollToSection('deal-report')} className="w-full bg-gold hover:bg-gold-light text-navy px-6 py-2.5 rounded font-semibold transition-colors" data-id="element-285">
              Access Deal Report
            </button>
          </div>}
      </div>
    </nav>;
}